export type USGRole = "engineer" | "new_engineer" | "manager" | "ops" | "executive" | "finance";

export const ROLE_DISPLAY_NAMES: Record<USGRole, string> = {
  engineer: "Field Engineer",
  new_engineer: "New Engineer",
  manager: "Engineering Manager",
  ops: "Operations Admin",
  executive: "Executive",
  finance: "Finance Lead",
};

export function getUserStatus(user: {
  banned: boolean | null | undefined;
  lastLoginAt: Date | string | null | undefined;
}): "active" | "pending" | "inactive" {
  if (user.banned) return "inactive";
  if (!user.lastLoginAt) return "pending";
  return "active";
}
